import React from "react";
import { Heart, Trophy, Zap, ShieldCheck, Shirt, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PageMeta from "../components/PageMeta";

export default function Concept() {
    return (
        <div className="max-w-5xl mx-auto px-6 py-16 space-y-16">
            <PageMeta
                title="Concept — Sponsormania.fr | Le micro-sponsoring sportif solidaire"
                description="Découvrez comment Sponsormania met en relation clubs sportifs amateurs et sponsors locaux pour financer les maillots. Service gratuit, 0% de commission."
            />
            <header>
                <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">
                    Le concept
                </div>
                <h1 className="font-display text-5xl md:text-8xl uppercase tracking-tight leading-[0.85]">
                    Une économie<br />du sport plus juste.
                </h1>
                <p className="text-zinc-300 text-xl mt-6 max-w-3xl">
                    Sponsormania.fr met en relation les clubs amateurs et les sponsors locaux qui veulent
                    s&apos;engager. Chaque maillot devient une œuvre collective : plusieurs sponsors,
                    un seul kit, zéro intermédiaire.
                </p>
            </header>

            <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="card-tu">
                    <Trophy className="text-orange-500 mb-3" />
                    <h3 className="font-display text-3xl uppercase tracking-tight mb-2">Pour les clubs</h3>
                    <p className="text-zinc-400">
                        Inscrivez votre club, exprimez vos besoins, recevez des propositions de sponsoring.
                        Vous gardez la main : vous validez ou refusez chaque sponsor.
                    </p>
                </div>
                <div className="card-tu">
                    <Heart className="text-orange-500 mb-3" />
                    <h3 className="font-display text-3xl uppercase tracking-tight mb-2">Pour les sponsors</h3>
                    <p className="text-zinc-400">
                        Choisissez vos clubs, sélectionnez vos emplacements (poitrine, dos, épaules…),
                        uploadez votre logo. À partir de 14€, donnez du sens à votre marque.
                    </p>
                </div>
                <div className="card-tu">
                    <Zap className="text-orange-500 mb-3" />
                    <h3 className="font-display text-3xl uppercase tracking-tight mb-2">Le seuil 19€</h3>
                    <p className="text-zinc-400">
                        Dès qu&apos;un maillot atteint 19€ HT cumulés et que le club valide la sélection,
                        il part directement en production chez l&apos;imprimeur.
                    </p>
                </div>
                <div className="card-tu">
                    <ShieldCheck className="text-orange-500 mb-3" />
                    <h3 className="font-display text-3xl uppercase tracking-tight mb-2">0% commission</h3>
                    <p className="text-zinc-400">
                        Service totalement gratuit. 100% de chaque euro va à la fabrication.
                        Transparence garantie.
                    </p>
                </div>
            </section>

            {/* PANTHER PARTNER */}
            <section
                data-testid="concept-panther-block"
                className="card-tu border-orange-500/20 flex flex-col md:flex-row md:items-center gap-6"
            >
                <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br from-orange-600 to-red-600 flex items-center justify-center">
                    <Shirt size={26} className="text-white" />
                </div>
                <div className="flex-1">
                    <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-1">
                        Notre partenaire fabricant
                    </div>
                    <h3 className="font-display text-3xl uppercase tracking-tight">
                        Les maillots sont fabriqués par <span className="text-orange-500">Panther</span>
                    </h3>
                    <p className="text-zinc-400 mt-2 text-sm">
                        Marque française spécialisée dans le textile sportif haut de gamme.
                        Impression HD, fabrication à la demande, livraison directe au club.
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3">
                    <Link
                        to="/panther"
                        data-testid="concept-panther-internal"
                        className="btn-ghost whitespace-nowrap"
                    >
                        En savoir plus <ArrowRight size={16} />
                    </Link>
                    <a
                        href="https://www.mypanther.fr"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="concept-panther-external"
                        className="btn-primary whitespace-nowrap"
                    >
                        mypanther.fr ↗
                    </a>
                </div>
            </section>

            <section className="text-center">
                <Link to="/register" className="btn-primary">Rejoindre Sponsormania.fr</Link>
            </section>
        </div>
    );
}
